import React, { useReducer, useMemo, useContext, useEffect } from 'react';
import { getApiClient, handleApiError, makeCancelTokenSource } from '../api_client/get';

const ACTIVATION_FLAG = 'activation_codes_feature_enabled';

const ActivationFlagContext = React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'load-settings-start': return { ...state, loaded: false };
    case 'load-settings-success': return { ...state, enabled: action.enabled, loaded: true };
    case 'load-settings-failure': return { ...state, errorMessage: action.message, loaded: true };
    default: throw new Error(`Unhandled action ${action.type}!`);
  }
};

export const ActivationFlagProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    enabled: false,
    errorMessage: null,
    loaded: false
  });
  const { enabled, errorMessage, loaded } = state;

  useEffect(() => {
    const cancelTokenSource = makeCancelTokenSource();
    getApiClient().getPlatformSettings(ACTIVATION_FLAG, cancelTokenSource)
      .then(({ data }) => {
        if (data.success) {
          dispatch({ type: 'load-settings-success', enabled: data.is_feature_enabled });
        } else {
          dispatch({ type: 'load-settings-failure', message: data.message });
        }
      })
      .catch((error) => {
        handleApiError(error, message => dispatch({ type: 'load-settings-failure', message: message }));
      });
    return () => cancelTokenSource.cancel();
  }, []);

  const value = useMemo(() => {
    return { enabled, errorMessage, loaded };
  }, [enabled, errorMessage, loaded]);

  return (
    <ActivationFlagContext.Provider value={value}>
      {children}
    </ActivationFlagContext.Provider>
  );
};

export const useActivationFlag = () => {
  const context = useContext(ActivationFlagContext);
  if (!context) throw new Error('useActivationFlag must be used within a ActivationFlagProvider');
  return context;
};
